import { createFileRoute } from '@tanstack/react-router';
import { requireSettledSession } from '@web/core/auth/password-change';
import {
  InstagramLoginCallback,
  type InstagramLoginCallbackSearch,
} from '@web/modules/conversations/settings/channels/instagram-login';

const text = (value: unknown): string | undefined =>
  typeof value === 'string' && value !== '' ? value : undefined;

/**
 * Where the Instagram login comes back to, through the API (ADR 0009). Outside the shell: it
 * usually runs in the small window the channel screen opened, which closes by itself.
 */
export const Route = createFileRoute('/channels/instagram/callback')({
  validateSearch: (search: Record<string, unknown>): InstagramLoginCallbackSearch => ({
    code: text(search['code']),
    state: text(search['state']),
    error: text(search['error']),
    error_reason: text(search['error_reason']),
  }),
  beforeLoad: async ({ context, location }) => {
    await requireSettledSession(context.queryClient, location.href);
  },
  component: InstagramLoginCallbackRoute,
});

function InstagramLoginCallbackRoute() {
  return <InstagramLoginCallback search={Route.useSearch()} />;
}
